<transpile *ngIf="targetStringWithoutMatches" [content]="targetStringWithoutMatches" />
<ng-container *ngFor="let substring of substrings">
  <ng-container *ngIf="substring.mark"><mark>{{substring.content}}</mark></ng-container>
  <ng-container *ngIf="!substring.mark">{{substring.content}}</ng-container>
</ng-container>
